import styles from "./styles.module.scss";

export const RoleOption = ({ Icon, isActive, label }) => {
  return (
    <div
      className={styles[isActive ? "activeRoleOption" : "roleOption"]}
      style={{ width: "100%" }}
    >
      <Icon height={17} width={17} color={isActive ? "white" : "#242B42"} />
      <div>{label} </div>
    </div>
  );
};
